import { useEffect, useState } from 'react'
import ApiService from '../../common/ApiCalls'
import { useNavigate } from 'react-router-dom'

const useLayoutConfiguration = (setIsLoading, setIsSnackbarOpen) => {
  const [selectedObjectType, setSelectedObjectType] = useState('asset')
  const [layouts, setLayouts] = useState([])
  const [, setIndustries] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    fetchData(selectedObjectType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedObjectType])

  const fetchData = async (objectType) => {
    setIsLoading(true)
    try {
      const layoutsResponse = await ApiService().listLayout(objectType)
      const layoutsData = layoutsResponse

      const industriesResponse = await ApiService().getIndustries()
      const industriesData = industriesResponse

      const industryIdToName = {}
      industriesData.forEach((industry) => {
        industryIdToName[industry.id] = industry.name
      })

      const enhancedLayouts = layoutsData.map((layout) => {
        let industryNames = []
        if (layout.industry_ids && layout.industry_ids.length > 0) {
          industryNames = layout.industry_ids
            .map((id) => industryIdToName[id])
            .filter((name) => name)
        } else if (layout.is_default) {
          industryNames = ['Default']
        } else {
          industryNames = ['None']
        }
        return { ...layout, industryNames }
      })

      setLayouts(enhancedLayouts)
      setIndustries(industriesData)
    } catch (error) {
      console.error('Error fetching data:', error)
      setIsSnackbarOpen({
        isOpen: true,
        severity: 'error',
        message: 'Failed to load layouts or industries',
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleRowSelect = (layoutId) => {
    console.log('Selected Layout ID:', layoutId)
    navigate(`/LayoutEditor/${layoutId}?objectType=${selectedObjectType}`)
  }

  const handleCreateNewLayout = () => {
    console.log('Create New Layout clicked')
    navigate(`/LayoutEditor?objectType=${selectedObjectType}`)
  }

  const handleDeleteLayout = async (layoutId, layoutName) => {

    setIsLoading(true)
    try {
      await ApiService().deleteLayout(layoutId) 
      await fetchData(selectedObjectType)

      setIsSnackbarOpen({
        isOpen: true,
        severity: 'success',
        message: `Layout "${layoutName}" deleted successfully.`,
      })
    } catch (error) {
      console.error('Error deleting layout:', error)
      setIsSnackbarOpen({
        isOpen: true,
        severity: 'error',
        message: `Failed to delete layout "${layoutName}".`,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return {
    selectedObjectType,
    setSelectedObjectType,
    layouts,
    handleRowSelect,
    handleCreateNewLayout,
    handleDeleteLayout, 
  }
}

export default useLayoutConfiguration
